import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  LinearProgress,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReceiptServiceForPatientDTO } from '../../../../../api/DashboardWidgetDTO';
import { DashboardWidgetsClient } from '../../../../../api/DashboardWidgetsClient';
import { REACT_APP_PORTAL_API_URL } from '../../../../../KeyVariables';
import { MedicalAnalysisResultMedicalAnalysisTestDTO } from '../../../../../api/MedicalAnalysisDTO';

interface MedicalAnalysisBatchDialogProps {
  open: boolean;
  handleClose: () => void;
  medicalAnalysisBatchId?: number;
}

const MedicalAnalysisBatchDialog: React.FC<MedicalAnalysisBatchDialogProps> = ({
  open,
  handleClose,
  medicalAnalysisBatchId,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [receiptServices, setReceiptServices] = useState<ReceiptServiceForPatientDTO[]>([]);
  const [medicalAnalysisTestsRequests, setMedicalAnalysisTestRequests] = useState<MedicalAnalysisResultMedicalAnalysisTestDTO[]>([]);

  const medicalAnalysisClient = new DashboardWidgetsClient(REACT_APP_PORTAL_API_URL);

  const fetchData = async () => {
    let data;
      data = await medicalAnalysisClient.medicalanalysisresultmedicaltestrequestsbymedicalanalysisbacthid(medicalAnalysisBatchId);
    if (data) {
      setMedicalAnalysisTestRequests(data);
      let receiptServiceIds = data.map((m) => {
        if (m.receiptService?.id && m.receiptService?.id > 0) {
          return m.receiptService.id;
        }
      })
      receiptServiceIds = Array.from(new Set(receiptServiceIds.filter(i => i !== undefined))) as number[];
      if (receiptServiceIds != undefined && receiptServiceIds) {
        let receiptServices = await medicalAnalysisClient.receiptservicegetbyids(receiptServiceIds as number[]);
        if (receiptServices && receiptServices.length > 0) {
          setReceiptServices(receiptServices);
        }else{
          setReceiptServices([]);
        }
      }

    }
  }

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        await fetchData();
      } catch (ex) {
        console.error(ex);
      } finally {
        setLoading(false);
      }
    };
  
    if (open) {
      loadData();
    }
  }, [open, medicalAnalysisBatchId]);

  useEffect(() => {
    console.log(receiptServices);
  }, [receiptServices]);
  
  const { t } = useTranslation("Portal");
  const groupedData = medicalAnalysisTestsRequests.reduce((acc: any, service) => {
    const groupName = service.medicalAnalysisTest?.requestMedicalAnalysisTestGroupDTO?.name ?? 'without group';
    if (!acc[groupName]) {
      acc[groupName] = {
        groupObject:service.medicalAnalysisTest?.requestMedicalAnalysisTestGroupDTO,
        serviceGroup: service.medicalAnalysisTest?.requestMedicalAnalysisTestGroupDTO?.service,
        canSelectAll: service.medicalAnalysisTest?.requestMedicalAnalysisTestGroupDTO?.canSelectTests || false,
        canUncheckAll: service.medicalAnalysisTest?.requestMedicalAnalysisTestGroupDTO?.canUncheckAll || false,
        services: []
      };
    }
    acc[groupName].services.push(service);
    return acc;
  }, {});

  const getRowStyle = (status) => {
    switch (status) {
      // case 1:
      //   return { backgroundColor: '#d4edda', color: '#155724' };
      // case 2:
      //   return { backgroundColor: '#f8d7da', color: '#721c24' };
      // case 3:
      //   return { backgroundColor: '#fff3cd', color: '#856404' };
      default:
        return {}; 
    }
  };

  return (
    <>
    <Dialog open={open} onClose={handleClose} maxWidth="lg">
      <DialogTitle>{t("Portal_Analysis")}</DialogTitle>
      <DialogContent>
        {loading ? (
          <LinearProgress />
        ) : (
          <TableContainer>
            <Table size='small'>
              <TableHead>
                <TableRow>
                  <TableCell>{t("Portal_Cod")}</TableCell>
                  <TableCell>{t("Portal_Name")}</TableCell>
                  {/* <TableCell>{t("Portal_Statut")}</TableCell> */}
                  <TableCell>{t("Portal_Price")}</TableCell>
                  {/* <TableCell>{t("Portal_Statut")}</TableCell> */}
                  {/* <IconButton onClick={() => handlePrintRow(medicalAnalysisBatchId)} disabled={isLoading}>
                    {isLoading ? <CircularProgress size={24} /> : <PrintIcon />}
                  </IconButton> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(groupedData).map((groupName) => {
                  const group = groupedData[groupName];
                  return (
                    <React.Fragment key={groupName}>
                      {!group.canSelectAll && group.canUncheckAll ? (
                        <TableRow style={getRowStyle(
                          receiptServices.find(
                            (receipt) => receipt.id === group.services[0]?.receiptService?.id
                          )?.receiptServicePaymentStatus?.id || ''
                        )}>
                          <TableCell>{group?.serviceGroup?.serviceCode}</TableCell>
                          <TableCell>{groupName}</TableCell>
                          {/* <TableCell>{group?.services[0].medicalAnalysisResult?.medicalAnalysisResultStatus?.name}</TableCell> */}
                          <TableCell>{group?.groupObject?.service?.price} MDL</TableCell>
                          {/* <TableCell>
                            {receiptServices.find(
                              (receipt) => receipt.id === group.services[0]?.receiptService?.id
                            )?.receiptServicePaymentStatus?.name || ''}
                          </TableCell> */}
                         
                        </TableRow>
                      ) : (
                        group.services.map((service, index) => {
                          const serviceReceiptService = receiptServices.find(
                            (receipt) => receipt.id === service.receiptService?.id
                          );
  
                          if (service.medicalAnalysisTest?.service?.id && service.medicalAnalysisTest.service.id > 0) {
                            return (
                              <TableRow key={index} style={getRowStyle(serviceReceiptService?.receiptServicePaymentStatus?.id || '')}>
                                <TableCell>{service.medicalAnalysisTest?.service?.serviceCode}</TableCell>
                                <TableCell>{service.medicalAnalysisTest?.service?.shortName}</TableCell>
                                {/* <TableCell>{service.medicalAnalysisResult?.medicalAnalysisResultStatus?.name}</TableCell> */}
                                <TableCell>{service.medicalAnalysisTest?.service?.price} MDL</TableCell>
                                {/* <TableCell>{serviceReceiptService?.receiptServicePaymentStatus?.name}</TableCell> */}
                               
                              </TableRow>
                            );
                          }
                        })
                      )}
                    </React.Fragment>
                  );
                })}

{
  groupedData 
   &&
   <TableRow>
        <TableCell colSpan={2} style={{ fontWeight: "bold", textAlign: "right" }}>
       
        </TableCell>
        {/* Общая сумма по service */}
        <TableCell style={{ fontWeight: "bold" }}>
        {t("Total Pret")}: {" "}
          {Object.values(groupedData)
  .reduce((total: number, group: any) => {
    // Проверяем свойства группы
    if (group.canSelectAll === false && group.canUncheckAll === true) {
      // Используем serviceGroup
      return (
        total +
        (group.serviceGroup?.price || 0) 
      );
    }

    return (
      total +
      group.services.reduce((sum: number, service: any) => {
        return sum + (service.medicalAnalysisTest?.service?.price || 0); 
      }, 0)
    );
  }, 0)
  .toFixed(2)}{" "}
          MDL
        </TableCell>
        {/* Общая сумма по receiptService */}
        {/* <TableCell style={{ fontWeight: "bold" }}>
          Spre achitare: {" "}
         {
         totalSum.toFixed(2)
         }{" "}
          MDL
        </TableCell> */}
        
      </TableRow>
}


              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          {t("Portal_Close")}
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};

export default MedicalAnalysisBatchDialog;
